import { Drawer } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ICON } from "../assets";
import { useAuth } from "../components/Auth/useAuth";
import { useVrpRedirect } from "../components/Auth/useVrpRedirect";
import CurrentCart from "../components/Carts/CurrentCart";
import { useCart } from "../components/Carts/useCart";
import ApplicationHeader from "../components/Headers/ApplicationHeader/ApplicationHeader";
import FSLoader from "../components/Loaders/FSLoader";
import Page from "../components/Page/Page";
import PLVCard from "../components/TesteursPLV/PLVCard";
import useTranslations from "../components/Translations/useTranslations";
import UiButton from "../components/ui/UiButton";
import UiIcon from "../components/ui/UiIcon";
import UiTag, { UI_TAG_TYPE } from "../components/ui/UiTag";
import { navigate } from "../routes";
import { admin } from "../routes/admin";
import sdk from "../sdk/sdk";
import { price, round2 } from "../utils";
import "./PLVPage.css";

function PLVCardWrapper({ pvl, plvCart, addInCart, inCart }) {
  return (
    <Col md={6} xl={3} lg={4} className="mb-4">
      <PLVCard
        article={pvl}
        PLV_CART={plvCart}
        addInCart={addInCart}
        inCart={inCart}
      />
    </Col>
  );
}

function PLVPage() {
  const CART_KEY_PLV = "PLV";

  const [{ user }] = useAuth();
  useVrpRedirect();
  const [{ current_cart }, cartSDK] = useCart(user?.client_profile?.id);
  const trl = useTranslations();

  const [cartOpened, isCartOpen] = useState(false);
  const [loading, isLoading] = useState(true);
  const [recommandations, setRecommandations] = useState([]);
  const [testeurs_plv, setTesteurs_plv] = useState([]);

  useEffect(() => {
    if (!current_cart) {
      navigate.goBack();
    }
  }, [current_cart]);

  const cart_data = cartSDK.getCartData();
  const max_mt_plv_offert = cartSDK.getMaxMtPLVOffert(cart_data);
  const mt_plv_in_cart = Math.round(cart_data.cumul_plv_in_cart * 100) / 100;

  useEffect(() => {
    if (max_mt_plv_offert === 0) {
      const creator = user.client_profile?.id;
      const products = current_cart.products;
      if (products[CART_KEY_PLV]) {
        delete products[CART_KEY_PLV];
        cartSDK.addInCart({
          creator,
          product: products,
        });
      }
      _handleGoToPreviousPage();
    }
  }, [max_mt_plv_offert]);

  const _addPLVInCart = (_article, qte_commande) => {
    const products = current_cart.products;
    const PLV_CART = products[CART_KEY_PLV];
    const creator = user.client_profile?.id;
    const custom_remise = 0;

    const article = { ..._article, generique: {} };

    if (PLV_CART === undefined) {
      // First PLV_ARTICLE
      cartSDK.addInCart({
        creator,
        product: {
          [CART_KEY_PLV]: [{ article, qte_commande, custom_remise }],
        },
      });
    } else {
      const articleIndex = PLV_CART.findIndex(
        (art) => art.article.CODART === article.CODART,
      );
      if (articleIndex >= 0) {
        if (qte_commande > 0) {
          // Article is already in cart
          PLV_CART[articleIndex] = { article, qte_commande, custom_remise };
          cartSDK.addInCart({
            creator,
            product: {
              [CART_KEY_PLV]: PLV_CART,
            },
          });
        } else {
          PLV_CART.splice(articleIndex, 1);
          cartSDK.addInCart({
            creator,
            product: {
              [CART_KEY_PLV]: PLV_CART,
            },
          });
        }
      } else {
        cartSDK.addInCart({
          creator,
          product: {
            [CART_KEY_PLV]: [
              ...PLV_CART,
              { article, qte_commande, custom_remise },
            ],
          },
        });
      }
    }
  };

  const _isInPLV_CART = (codart) => {
    if (!current_cart) return false;
    return (
      current_cart.products[CART_KEY_PLV] &&
      current_cart.products[CART_KEY_PLV].findIndex(
        (art) => art.article.CODART === codart,
      ) >= 0
    );
  };

  let codarts = [];
  if (current_cart && current_cart?.products) {
    Object.keys(current_cart.products).map((key) => {
      if (current_cart.products[key]) {
        current_cart.products[key].map((art) => {
          codarts.push(art.article.CODART.toString());
        });
      }
    });
  }

  useEffect(() => {
    isLoading(true);
    if (codarts) {
      const queryParam = [...codarts];
      queryParam.codcli = current_cart.client.CODCLI;
      sdk.products.associateProducts.getCollection(queryParam).then((data) => {
        if (data.success) {
          const testerPlv = data.payload.testeurs_plv
            .map((el) => {
              el.label = trl.data.message("ART", "CODART", el.CODART, "LIBART");
              return el;
            })
            .sort((a, b) => (a.label < b.label ? -1 : 1));
          setTesteurs_plv(testerPlv);
          setRecommandations(data.payload.recommandations);
        }
        isLoading(false);
      });
    }
  }, []);

  const _handleGoToPreviousPage = (e) => {
    navigate.push(admin.APP_NAVIGATION, {
      critere: user?.nav_codfag || "start",
    });
  };

  function renderPlvDetails() {
    const amountExceedsLimit = mt_plv_in_cart > max_mt_plv_offert;
    const calculatedPrice = price(round2(max_mt_plv_offert - mt_plv_in_cart));
    const buildAmountSection = () => {
      const containerClass = `pvl-amount-section-container ${
        amountExceedsLimit ? "exceeds-limit" : ""
      }`;
      return (
        <React.Fragment>
          <div className={containerClass}>
            <span>{calculatedPrice + " €"}</span>
            <UiIcon icon={ICON.piggyBankIcon} alt="piggy-bank-icon" size="md" />
          </div>
        </React.Fragment>
      );
    };

    const pvlDetailText = () => {
      if (amountExceedsLimit) {
        const amount = calculatedPrice.replace("-", "");
        return `Vous avez dépensé tout votre crédit, vous devrez régler ${amount} €.`;
      }
      return `Vous bénéficiez de ${calculatedPrice} € offerts sur la PLV.`;
    };

    return (
      <React.Fragment>
        <Container>
          <div
            className="plv-page-back-container"
            onClick={_handleGoToPreviousPage}
            style={{ cursor: "pointer" }}
          >
            <UiIcon icon={ICON.arrowLeftIcon} size="md" />
            <span> Catalogue </span>
          </div>
        </Container>
        <Container className="plv-page-header">
          Compléter ma commande en PLV
        </Container>
        <Container>
          <div className="plv-detail-container">
            <div className="plv-detail-text">{pvlDetailText()}</div>
            <UiTag
              content={buildAmountSection()}
              uiTagType={
                amountExceedsLimit
                  ? UI_TAG_TYPE.critical
                  : UI_TAG_TYPE.successColor
              }
              size="sm"
            />
          </div>
        </Container>
      </React.Fragment>
    );
  }

  function orderControlPanel() {
    return (
      <React.Fragment>
        <div className="order-control-panel">
          <UiButton
            classNames={["ml-2"]}
            content={trl.message("CompleteOrderPage.finishOrderAction")}
            onClick={() => {
              navigate.push(admin.FINISH_ORDER);
            }}
          />
          <UiButton
            classNames={["ml-2"]}
            content={<i className={"fa fa-shopping-cart"}></i>}
            onClick={() => isCartOpen(true)}
          />
        </div>
        <Drawer
          anchor="right"
          open={cartOpened}
          onClose={() => isCartOpen(false)}
        >
          <CurrentCart
            disabled_plv_infos={true}
            closeCart={() => isCartOpen(false)}
          />
        </Drawer>
      </React.Fragment>
    );
  }

  function renderPVLCardList(plv_list) {
    return (
      <React.Fragment>
        <Row className="mb-3">
          {plv_list?.map((el) => (
            <PLVCardWrapper
              key={el.CODART}
              pvl={el}
              plvCart={current_cart.products[CART_KEY_PLV]}
              addInCart={_addPLVInCart}
              inCart={_isInPLV_CART(el.CODART)}
            />
          ))}
        </Row>
      </React.Fragment>
    );
  }

  function renderRecommendationsPvl() {
    if (recommandations.length > 0) {
      return (
        <React.Fragment>
          <Container className="pvl-products-container">
            <div className="pvl-products-header">
              Recommandations (en fonction de votre commande)
            </div>
            {renderPVLCardList(recommandations)}
          </Container>
        </React.Fragment>
      );
    }
  }

  function renderPlv() {
    const plv = testeurs_plv.filter((plv) =>
      plv.TESTEUR_ou_PLV.startsWith("PLV"),
    );
    if (plv.length > 0) {
      return (
        <React.Fragment>
          <Container className="pvl-products-container">
            <div className="pvl-products-header">Autres éléments de PLV</div>
            {renderPVLCardList(plv)}
          </Container>
        </React.Fragment>
      );
    }
  }

  function renderLoading() {
    if (loading) {
      return (
        <React.Fragment>
          <Container className="loading-plv">
            <Row>
              <FSLoader />
            </Row>
          </Container>
        </React.Fragment>
      );
    }
  }

  return (
    <React.Fragment>
      <ApplicationHeader headerConfig={{ showcart: true }} />
      {renderPlvDetails()}
      <Page>
        {renderLoading()}
        {renderRecommendationsPvl()}
        {renderPlv()}
      </Page>
      {orderControlPanel()}
    </React.Fragment>
  );
}

export default PLVPage;
